import { render } from "./LoadingPanel.vue?vue&type=template&id=407c39b6"
import script from "./LoadingPanel.vue?vue&type=script&lang=js"
export * from "./LoadingPanel.vue?vue&type=script&lang=js"

import "./LoadingPanel.vue?vue&type=style&index=0&id=407c39b6&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__